module.exports = __webpack_public_path__ + "img/traffic-light-stop.05cf3d13.svg";